var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhitePencilIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.52,
    height: 12.518,
    viewBox: "0 0 12.52 12.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit_FILL1_wght200_GRAD0_opsz24",
    d: "M183.611-781.408l-2-1.995.983-.984a.773.773,0,0,1,.569-.23.773.773,0,0,1,.569.23l.86.86a.784.784,0,0,1,.234.565.752.752,0,0,1-.225.565ZM172.954-772.1a.628.628,0,0,1-.463-.184.628.628,0,0,1-.184-.463v-1.093a.644.644,0,0,1,.045-.241.653.653,0,0,1,.149-.217l8.53-8.534,2,2L174.5-772.3a.653.653,0,0,1-.216.15.643.643,0,0,1-.241.045Z",
    transform: "translate(-172.307 784.617)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePencilIcon);
export default __webpack_public_path__ + "static/media/white_pencil_icon.2d59c969371e3261d16e3710f06f4397.svg";
export { ForwardRef as ReactComponent };